import React from "react";
import { useUID } from "react-uid";

export default function Question({ color, size }) {
  const id = useUID();
  const svgSize = size === "sm" ? 11 : 22;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={svgSize}
      height={svgSize}
      viewBox="0 0 22 22"
    >
      <defs>
        <path
          id={id}
          d="M11 0c6.065 0 11 4.935 11 11s-4.935 11-11 11S0 17.065 0 11 4.935 0 11 0zm0 2c-4.962 0-9 4.038-9 9 0 4.963 4.038 9 9 9 4.963 0 9-4.037 9-9 0-4.962-4.037-9-9-9zm-.71 13.292c.38-.37 1.05-.37 1.42 0 .09.09.16.2.21.33.05.12.08.25.08.38 0 .269-.1.519-.29.7a1 1 0 0 1-.71.3 1 1 0 0 1-.92-.62.995.995 0 0 1-.08-.38c0-.13.03-.26.08-.38.05-.13.12-.24.21-.33zM7.146 7.668a4.008 4.008 0 0 1 5.101-2.446 4.003 4.003 0 0 1 2.673 3.78c0 2.642-3.307 3.821-3.684 3.946a1.001 1.001 0 0 1-.633-1.897c.6-.203 2.317-1.017 2.317-2.05a2.002 2.002 0 0 0-1.336-1.892 2.004 2.004 0 0 0-2.55 1.223 1 1 0 0 1-1.888-.664z"
        />
      </defs>
      <use fill={color} fillRule="evenodd" xlinkHref={`#${id}`} />
    </svg>
  );
}
